


















import { Component, Mixins, Watch } from 'vue-property-decorator'
import Cookies from 'js-cookie'
import { DateTime } from 'luxon'

// components
import CoursesSettings from '@/components/CoursesSettings.vue'
import LinkTabs from '@/components/_uikit/LinkTabs.vue'
import ProlongationBanner from '@/components/ProlongationBanner.vue'
import ProlongationModal from '@/components/modals/ProlongationModal.vue'
// mixins
import MasterGroupMixin from '@/mixins/MasterGroupMixin'
import NotifyMixin from '@/mixins/NotifyMixin'
// store
import MasterEducationModule from '@/store/modules/master/education'
// utils
import { isCheckProlongationEnable, timeZoneName } from '@/utils/constants'

@Component({
  components: {
    CoursesSettings,
    LinkTabs,
    ProlongationBanner,
    ProlongationModal,
  },
})
export default class Exercises extends Mixins(MasterGroupMixin, NotifyMixin) {
  private get tabs () {
    const res = [
      {
        name: 'Домашняя работа',
        to: { name: 'master.exercises.list' },
      },
      {
        name: 'Тест на повторение',
        to: { name: 'master.exercises.repetition' },
      },
    ]

    if (MasterEducationModule.masterGroups.some(group => group.hasOptionalHomeworks)) {
      res.push({
        name: 'Дополнительные задания',
        to: { name: 'master.exercises.optional' },
      })
    }

    return res
  }

  private hasProlongation = false
  private showProlongationModal = false

  private mounted() {
    if (isCheckProlongationEnable)
      this.checkProlongationMasterGroup()
    if (this.$route.name === 'master.exercises') {
      this.$router.replace({ name: 'master.exercises.list' })
    }
  }

  private checkProlongationMasterGroup() {
    MasterEducationModule.checkProlongationMasterGroup(this.currentMasterGroupID)
      .then(response => {
        this.hasProlongation = response.hasProlongation
        if (response.hasProlongation && !Cookies.get(`exercise-${this.currentMasterGroupID}`)) {
          this.showProlongationModal = true
          Cookies.set(`exercise-${this.currentMasterGroupID}`, 1, { expires: new Date((DateTime.now().setZone(timeZoneName).endOf('month') as any).ts) })
        }
      })
      .catch(this.notifyError)
  }

  @Watch('currentMasterGroupID')
  private watchCurrentMasterGroupID() {
    if (isCheckProlongationEnable)
      this.checkProlongationMasterGroup()
  }
}
